import { Form, Input, Tooltip } from 'antd'
import { useEffect } from 'react'
import { usePricingSchemasTranslation } from 'hooks/translation/usePricingSchemaTranslation'
import { usePlanTranslation } from 'hooks/translation/usePlanTranslation'
import { InfoTextWrapper } from 'atom/price'
import { Tenant } from 'models/tenant'
import { useDiscountSchemaTranslation } from 'hooks/translation/useDiscountSchemaTranslation'
import { QuestionIcon } from 'assets/svg/questionMark'

interface props {
  index: number
  tenant: Tenant
  discountNameExists: { [key: number]: boolean }
  promoCodeExists: { [key: number]: boolean }
  nameCheck: (value: string, type: string, index: number) => void
  getDiscountNames: (tenantId: number) => void
}

export const DiscountNameSectionModal: React.FC<props> = ({
  index,
  tenant,
  discountNameExists,
  promoCodeExists,
  nameCheck,
  getDiscountNames,
}) => {
  const { nameInUseText } = usePricingSchemasTranslation()
  const { nameText } = usePlanTranslation()
  const { promoCodeText, promoCodeInfoText, discountPlanNameText, promoCodeHelpText } = useDiscountSchemaTranslation()

  useEffect(() => {
    getDiscountNames(Number(tenant.id))
  }, [])

  return (
    <>
      <div style={{ display: 'flex' }}>
        <Form.Item
          className="name-title"
          rules={[{ required: true }]}
          validateStatus={discountNameExists[index] ? 'error' : ''}
          label={<>{nameText}:</>}
          name={[index, 'name']}
          style={{ marginRight: '10px', alignItems: 'flex-start' }}
          help={discountNameExists[index] ? nameInUseText : ''}
        >
          <Input
            onChange={(e) => {
              nameCheck(e.target.value, 'discountName', index)
            }}
            placeholder={discountPlanNameText}
            style={{ fontSize: '14px', paddingLeft: '12px' }}
          />
        </Form.Item>
      </div>
      <div style={{ display: 'flex' }}>
        <Form.Item
          className="promo-code-title"
          rules={[{ required: true }]}
          validateStatus={promoCodeExists[index] ? 'error' : ''}
          label={<>{promoCodeText}:</>}
          name={[index, 'promo_code']}
          style={{ marginRight: '10px', alignItems: 'flex-start' }}
          help={promoCodeExists[index] ? 'Promo code already in use' : promoCodeInfoText}
        >
          <Input
            onChange={(e) => {
              nameCheck(e.target.value, 'promoCode', index)
            }}
            placeholder={promoCodeText}
            style={{ fontSize: '14px', paddingLeft: '12px' }}
            maxLength={255}
          />
        </Form.Item>

        <InfoTextWrapper
          style={{
            alignSelf: 'flex-start',
            marginTop: '12px',
          }}
          className="promo-code-info-text"
        >
          <Tooltip title={promoCodeHelpText}>
            <div>
              <QuestionIcon />
            </div>
          </Tooltip>
        </InfoTextWrapper>
      </div>
    </>
  )
}
